export default {
  prevPage: '',
  page: '',
  query: null,
  hashParams: null,
  redirectURI: '',
  isReady: false,
  pageLoading: false,
};
